import { render, staticRenderFns } from "./customer-select-modal.vue?vue&type=template&id=8f7bf804&scoped=true&"
import script from "./customer-select-modal.vue?vue&type=script&lang=js&"
export * from "./customer-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./customer-select-modal.vue?vue&type=style&index=0&id=8f7bf804&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7bf804",
  null
  
)

export default component.exports